import React, { useState } from 'react';

//MUI
import CircularProgress from '@mui/material/CircularProgress';
import CssBaseline from '@mui/material/CssBaseline';
import FormControl from '@mui/material/FormControl';
// import TextField from "@mui/material/TextField";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Input, Typography } from '@mui/material';
import backgroundImg from '../../assets/BackgroundNight.jpg';
//Selfmade
import Copyright from './copyright';

//React router dom
import { useNavigate } from 'react-router-dom';
import { ArrowBackIos } from '@mui/icons-material';
import mainURL from '../../config/environment';
import $ from 'jquery';
//import { width } from "@mui/system";
import { styled } from '@mui/material/styles';
export default function ForgotPassword() {
  const navigate = useNavigate();

  //Load management
  const [isLoading, setLoading] = useState(false);
  const [model, setModel] = useState({
    email: '',
  });

  const ButtonCss = styled(Button)`
    background: #44c554;
    font-weight: bold;
    text-transform: unset;
    font-size: 16px;
    color: white;
    &:hover,
    &:focus {
      background: #3db449;
    }
    &:active {
      background: #3db449;
    }
  `;

  const styles = {
    backgroundImg: {
      backgroundImage: `url(${backgroundImg})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    },
    passwordInput: {
      backgroundColor: '#E4E4E4',
      borderRadius: '4px',
      opacity: '70%',
      fontWeight: '600',
      paddingLeft: 2,
      paddingRight: 2,
      height: '2.7rem',
      border: '2px',
      borderColor: 'red',
    },
    boxCenter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    boxContainer: {
      height: '90%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    imgBoxContainer: {
      maxWidth: '32rem',
      width: '90%',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      borderRadius: '30px',
      padding: '2rem',
      '@media (max-width: 768px)': {
        padding: '1.5rem',
        maxWidth: '28rem',
      },
      '@media (max-width: 480px)': {
        padding: '1rem',
        maxWidth: '24rem',
      },
    },
    titleBoxContainer: {
      mt: 6,
    },
    backButton: {
      backgroundColor: 'transparent',
      borderColor: 'white',
      textTransform: 'unset',
      fontWeight: 'bold',
      color: 'white',
      '&:hover': {
        borderColor: 'white',
      },
    },
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    $.ajax({
      method: 'POST',
      url: mainURL + 'login/forgot-password',
      contentType: 'application/json',
      data: JSON.stringify(model),
    })
      .done((res) => {
        setLoading(false);
        localStorage.setItem('userInfo', JSON.stringify(res));
        navigate('/Login');
      })
      .fail((res) => {
        alert(res.responseText);
      });
  };

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    setModel({
      ...model,
      [name]: value,
    });
  };

  return (
    <Box
      component="main"
      style={styles.backgroundImg}
      sx={{
        height: '100vh',
        width: '100vw',
        padding: '1rem 2rem',
      }}
    >
      <CssBaseline />

      <Box
        sx={{
          height: '3rem',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Button
          sx={styles.backButton}
          startIcon={<ArrowBackIos />}
          onClick={() => navigate('/Login')}
        >
          Back to login
        </Button>
      </Box>

      <Box sx={{ ...styles.boxContainer, ...styles.boxCenter }}>
        <Box sx={{ ...styles.imgBoxContainer, ...styles.boxCenter }}>
          <img
            src="assets/images/Americas-Logo.png"
            alt="Logo"
            style={{
              height: 'auto',
              maxWidth: '16rem',
              width: '100%',
              '@media (max-width: 768px)': {
                maxWidth: '12rem',
              },
              '@media (max-width: 480px)': {
                maxWidth: '8rem',
              },
            }}
          />
          <Box sx={{ ...styles.titleBoxContainer, ...styles.boxCenter }}>
            <Typography
              variant="h2"
              sx={{
                color: 'white',
                fontWeight: '700',
                fontSize: '50px',
                '@media (max-width: 768px)': {
                  fontSize: '35px',
                },
                '@media (max-width: 480px)': {
                  fontSize: '28px',
                },
              }}
            >
              {'Forgot password?'}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'white',
                fontWeight: '500',
                fontSize: '16px',
                '@media (max-width: 768px)': {
                  fontSize: '14px',
                },
                '@media (max-width: 480px)': {
                  fontSize: '12px',
                },
              }}
            >
              {
                'Enter the email address you used when you joined and we’ll send you instructions to reset your password.'
              }
            </Typography>
          </Box>

          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 5, width: '100%' }}>
            <FormControl fullWidth>
              <Typography sx={{ color: 'white', fontSize: '16px', mb: '0.5rem' }}>
                {'Email'}
              </Typography>

              <Input
                sx={styles.passwordInput}
                margin="dense"
                required
                name="email"
                type={'text'}
                id="email"
                autoComplete="email"
                onChange={handleChange}
              />
            </FormControl>

            {isLoading ? (
              <Grid container justifyContent={'center'} sx={{ mt: 3, mb: 2 }}>
                <CircularProgress />
              </Grid>
            ) : (
              <React.Fragment>
                <ButtonCss type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 1 }}>
                  Get recover link
                </ButtonCss>
              </React.Fragment>
            )}
            <Copyright sx={{ mt: 4 }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
